import { Reveal } from '../components/Reveal';
import { Pipeline } from '../graphs/Pipeline';

export function Promise() {
  return (
    <section className="block" id="protocole" data-screen-label="02 Protocole">
      <div className="wrap">
        <div className="sec-head">
          <div><div className="sec-num"><b>02</b> &nbsp; la promesse</div></div>
          <div className="sec-tag">PROTOCOLE / PIPELINE</div>
        </div>
        <Reveal as="h2" className="sec-title">Un fil. <em>Toutes les plateformes.</em></Reveal>
        <Reveal as="p" className="sec-intro">
          furtif.fm récupère ce que tu écoutes — où que ce soit — le normalise via un identifiant universel (ISRC), et le redistribue à tes amis en temps réel. Une couche sociale, ouverte, posée par-dessus les jardins clos.
        </Reveal>
        <Reveal className="promise-svg-wrap"><Pipeline /></Reveal>
        <Reveal as="p" className="promise-sub">
          <em>furtif.fm</em> est l'infrastructure invisible qui laisse passer la musique entre les murs.
        </Reveal>
      </div>
    </section>
  );
}
